import { connect } from 'react-redux';

import ReceiptsView from '../components/ReceiptsView';

const mapActionCreators = {};
const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(ReceiptsView);
